/* eslint-disable react/prop-types */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, { useState, useCallback } from 'react';
import { Button } from '@material-ui/core';
import heart from '@assets/images/klips/heart.png';
import LoginModalComponent from '@features/Authentication';

function LikeButton({ likeStatus, loggedIn, ...props }) {
  const [openModal, setOpenModal] = useState(false);
  const openLoginModal = () => {
    setOpenModal(true);
  };
  const getLoggedInAction = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);

  const modalActions = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);

  return (
    <>
      <Button onClick={() => {
        if (loggedIn) {
          openLoginModal();
        } else if (loggedIn === false) {
          props.likeKlip();
        }
      }}
      >
        {
          likeStatus
            ? <img src={heart} alt='heart' />
            : <img src={heart} style={{ opacity: 0.6 }} alt='heart' />
        }
      </Button>
      {
        openModal
          ? (
            <LoginModalComponent
              isOpenModal={openModal}
              modalFunc={modalActions}
              loggedInFunc={getLoggedInAction}
              isOpenReCaptcha={props.isOpenReCaptcha}
            />
          )
          : null
      }
    </>
  );
}

export default LikeButton;
